document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("collection-hero__modal");
  const button = document.getElementById("collection-hero__modal--button");
  const close = document.getElementsByClassName(
    "collection-hero__modal--close"
  )[0];
  
  if (button == null) return;
  button.onclick = () => {
    modal.style.display = "block";
  };

  close.onclick = function () {
    modal.style.display = "none";
  };

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
});
